package com.appsyde.shared.modules.ticket.domain

class LockedByOtherException(
    val lockedByAccountUserId: String,
    val lockedByDisplayName: String,
    val expiresAt: String,
    message: String? = "Ticket locked by another user",
    cause: Throwable? = null
) : Exception(message, cause)
